import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import { isEqual } from '../../../../services/lodashInJS'
import './FilterExperience.scss'

export default class FilterExperience extends PureComponent {
  static propTypes = {
    experiences: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ])
  }

  static defaultProps = {
    experiences: [],
  }

  constructor(props) {
    super(props)

    this.state = {
      experiences: this.props?.experiences?.length ? this.props.experiences : []
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (!isEqual(this.props.experiences, prevProps.experiences)) {
      this.setState({
        experiences: this.props.experiences
      })
    }
  }

  normValues(values) {
    return values.map((value) => value.label)
  }

  denormValues(values) {
    return values.map((value) => ({label: value, value}))
  }

  onChange = (values) => {
    return this.props.onChange(this.normValues(values))
  }

  onChecked = (event) => {
    let values = [
      ...this.state.experiences
    ]

    const target = event.target
    const value = target.checked
    const name = target.name

    if (value === true) {
      values = [
        ...values,
        name
      ]
    } else {
      values = values.filter(item => {
        return item !== name
      })
    }

    this.setState({experiences: values})

    return this.props.onChange(values)
  }

  render() {
    const experiences = this.props.conf.search.experiences

    return <div className="filter-experience-list">
      {experiences.map((item, key) => {
        return <div key={key} className="filter-experience">
          <input
            id={key + item.name}
            type="checkbox"
            name={item.name}
            onChange={this.onChecked}
            checked={this.state.experiences.includes(item.name)}
          />
          <label htmlFor={key + item.name}> {item.label}</label>
        </div>
      })}
    </div>
  }
}
